import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import { FiTruck, FiCheckCircle, FiXCircle, FiClock, FiUser, FiFileText, FiMapPin, FiHome } from "react-icons/fi";
import { T, DocStatusBadge } from "../../_components/Sales/SalesShared";
import { getDeliveryOrders, getDOKpis, deleteDeliveryOrder } from "../../_services/sales.service";

export default function DeliveryOrders() {
    return (
        <DocList
            docType="Delivery Order"
            basePath="/sales/delivery-orders"
            fetchList={getDeliveryOrders}
            fetchKpis={getDOKpis}
            deleteItem={deleteDeliveryOrder}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total Delivery Orders", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            customColumns={[
                { label: "Delivery Order No.", key: "id", render: (v) => <span style={{ fontWeight: 700 }}>{v}</span> },
                { label: "Date", key: "date" },
                { label: "Contact Person", key: "contactPerson" },
                { label: "Company Name", key: "customer" },
                { label: "Status", key: "status", render: (v) => <DocStatusBadge value={v} /> },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiTruck, label: "Delivery Date", key: "deliveryDate" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiFileText, label: "SO Ref.", key: "soRef", render: (v, r) => r.soRef || r.so_ref || r.so_id || r.soReference || r.quotationRef || "—" },
                { icon: FiMapPin, label: "Delivery Address", key: "shippingAddress" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "DO No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
                { key: "shippingAddress", label: "Delivery Address" },
            ]}
        />
    );
}